<template>
  <div
    class="home"
    :style="{
      backgroundImage:
        'url(' +
        $returnColor().path +
        ($store.state.selfData.member_id
          ? '/home-page_bg.png'
          : '/home-page_bg.png') +
        ')',
    }"
  >
    <div class="faqDilog" v-if="faqDialog">
      <div class="faqTitle">
        常见问题
        <div class="close" @click="faqDialog = false">
          <i class="van-icon van-icon-cross"></i>
        </div>
      </div>
      <div class="faqContent">
        <div
          v-for="(item, index) in question"
          :key="index"
          class="nested"
          @click="toggleShow(item)"
        >
          <h3 :class="{ active: item.show }">
            {{ item.title }} <img src="/arrow.png" alt="" class="arrow" />
          </h3>
          <div v-show="item.show" style="padding-right: 10px; margin-top: 5px">
            <NestedItem
              v-if="item.reply && item.reply.length"
              :items="item.reply"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- top -->
    <van-dialog
      v-model="checkModal"
      :title="$returnBuySel('出货') + '检查'"
      class="checkModal"
    >
      <div v-if="checkData" class="checkBody">
        <van-cell-group inset>
          <van-cell is-link @click="showMsg(checkData.on_duty_ds.note)">
            <template #title>
              <span class="custom-title">
                <van-icon
                  class="success"
                  v-if="checkData.on_duty_ds.check"
                  name="checked"
                />
                <van-icon class="err" v-else name="clear" />
                {{ $returnBuySel("出货") }}开关</span
              >
            </template>
            <template #right-icon>
              <p v-if="checkData.on_duty_ds.note" style="color: red">查看</p>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group inset>
          <van-cell is-link @click="showMsg(checkData.can_collection.note)">
            <template #title>
              <span class="custom-title">
                <van-icon
                  class="success"
                  v-if="checkData.can_collection.check"
                  name="checked"
                />
                <van-icon class="err" v-else name="clear" />
                {{ $returnBuySel("出货") }}权限</span
              >
            </template>
            <template #right-icon>
              <p v-if="checkData.can_collection.note" style="color: red">
                查看
              </p>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group inset>
          <van-cell is-link @click="showMsg(checkData.balance.note)">
            <template #title>
              <span class="custom-title">
                <van-icon
                  class="success"
                  v-if="checkData.balance.check"
                  name="checked"
                />
                <van-icon class="err" v-else name="clear" />
                余额</span
              >
            </template>
            <template #right-icon>
              <p v-if="checkData.balance.note" style="color: red">查看</p>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group inset>
          <van-cell
            is-link
            @click="showMsg(card.note)"
            v-for="(card, key) in checkData.cards"
            :key="key"
          >
            <template #title>
              <span class="custom-title">
                <van-icon class="success" v-if="card.check" name="checked" />
                <van-icon class="err" v-else name="clear" />
                {{ card.bank }}</span
              >
            </template>
            <template #right-icon>
              <p v-if="card.note" style="color: red">查看</p>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </van-dialog>
    <van-dialog v-model="mailSettingModal" title="常用邮件">
      <van-cell-group inset>
        <van-cell
          is-link
          v-clipboard:copy="card.mail"
          v-clipboard:success="onCopy"
          v-for="(card, key) in mailSetting"
          :key="key"
        >
          <template #title>
            <div
              style="
                white-space: nowrap;
                width: 200px;
                overflow: hidden;
                margin-right: 20px;
                text-overflow: ellipsis;
              "
            >
              <span class="custom-title" style="word-break: break-all">
                {{ card.title }}: {{ card.mail }}
              </span>
            </div>
          </template>
          <template #right-icon>
            <p style="color: red">复制</p>
          </template>
        </van-cell>
      </van-cell-group>
    </van-dialog>
    <van-dialog
      v-model="transferModal"
      title="余额转让"
      show-cancel-button
      :before-close="confirmTrans"
    >
      <van-field
        v-model="trans.account"
        name="账号"
        label="账号"
        placeholder="账号"
        :rules="[{ required: true, message: '请填写账号' }]"
      />
      <van-field
        v-model="trans.amount"
        name="金额"
        label="金额"
        type="number"
        placeholder="金额"
        :rules="[{ required: true, message: '请填写金额' }]"
      />
      <van-field
        v-model="trans.withdraw_password"
        name="提现密码"
        label="提现密码"
        placeholder="提现密码"
        type="password"
        :rules="[{ required: true, message: '请填写提现密码' }]"
      />
    </van-dialog>
    <van-dialog
      v-model="exchangeModal"
      title="红利转余额"
      show-cancel-button
      :before-close="confirmExchange"
    >
      <p class="exchangeInfo" style="font-size: 12px">
        可转红利{{ Math.floor(selfData.bonus * 10) / 10 }}
      </p>
      <van-field
        v-model="amount"
        name="金额"
        label="金额"
        type="number"
        placeholder="金额"
        :rules="[{ required: true, message: '请填写金额' }]"
      />
    </van-dialog>
    <van-dialog
      v-model="show"
      :title="'自动' + $returnBuySel('进货')"
      show-cancel-button
      :before-close="changeDsBefore"
    >
      <p style="text-align: center; font-size: 14px; color: red">
        金额可设置区间 {{ selfData.df_min }} ~ {{ selfData.df_max }}
      </p>
      <van-field name="switch" label="自动">
        <template #input>
          <van-switch
            v-model="on_duty_df"
            active-color="#009aaa"
            inactive-color="#cccccc"
            size="20"
          />
        </template>
      </van-field>
      <van-field
        v-if="selfData.alter_self_df_min == 1"
        v-model="selfData.self_df_min"
        name="最低"
        label="最低"
        placeholder="最低"
        type="number"
        :rules="[{ required: true, message: '请填写最低' }]"
      />
      <van-field
        v-else
        disabled
        v-model="selfData.df_min"
        name="最低"
        label="最低"
        placeholder="最低"
        type="number"
        :rules="[{ required: true, message: '请填写最低' }]"
      />
      <van-field
        v-model="selfData.self_df_max"
        name="最高"
        label="最高"
        type="number"
        placeholder="最高"
        :rules="[{ required: true, message: '请填写最高' }]"
      />
    </van-dialog>
    <!-- top -->
    <div class="wrap">
      <!-- left-icon="volume-o" -->
      <van-notice-bar :scrollable="false" class="notifyBar">
        <!-- :style="retrunBgColor()" -->
        <div slot="left-icon" class="leftIcon">
          <img src="@/assets/images/home page_notice_icon1.png" alt="" />
        </div>
        <div
          slot="right-icon"
          class="rightIcon"
          @click="$router.push('/bulletin')"
        >
          <img src="@/assets/images/home page_notice_icon2.png" alt="" />
        </div>
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
          style="color: black"
        >
          <van-swipe-item
            @click="showContent(ann)"
            v-for="ann in annList"
            :key="ann.id"
            >{{ ann.created_at }} {{ ann.title }}</van-swipe-item
          >
        </van-swipe>
      </van-notice-bar>
      <!-- :style="retrunTitleColor()" -->
      <div class="balanceWrap">
        <p class="b1">余额</p>
        <p class="numF b2">¥ {{ selfData.balance | thousands }}</p>
      </div>
      <div class="swipeWrap">
        <div class="testLeft" @click="$refs['ttest'].prev()">
          <img src="@/assets/images/home page_select icon_left.png" alt="" />
        </div>
        <!-- <img class="bsg" src="@/assets/images/shadow1.png" alt="" /> -->
        <van-swipe
          :loop="true"
          style="margin-top: 15px"
          ref="ttest"
          class="swipWrap"
          indicator-color="#009aaa"
        >
          <van-swipe-item class="loopWrap">
            <div class="t1">
              <div class="changeTitle">
                <span>交易</span>
                <span @click="$refs['ttest'].swipeTo(1)" class="active"
                  >自动</span
                >
              </div>
              <div class="content">
                <div
                  class="left"
                  @click="
                    $router.push({
                      path: '/orderRecord',
                      query: {
                        value: 0,
                      },
                    })
                  "
                >
                  <p class="title">红利</p>
                  <p class="numF">¥ {{ selfData.bonus | thousands }}</p>
                </div>
                <div class="right">
                  <p class="title">进行中</p>
                  <p class="numF">
                    ¥ {{ selfData.processing_amount | thousands }}
                  </p>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item class="loopWrap">
            <div class="t2">
              <div class="changeTitle">
                <span class="active" @click="$refs['ttest'].swipeTo(0)"
                  >交易</span
                >
                <span>自动</span>
              </div>
              <div class="content">
                <div class="left">
                  <div class="title">{{ $returnBuySel("进货") }}</div>
                  <div class="set">
                    <van-switch
                      style="margin-top: 5px"
                      :value="selfData.on_duty_df == 1"
                      @input="changeDf"
                      size="18"
                      active-color="#009aaa"
                      inactive-color="#cccccc"
                    />
                  </div>
                  <p class="numF">
                    ¥
                    <span v-if="selfData.alter_self_df_min == 1">
                      {{ selfData.self_df_min | thousands }}
                    </span>
                    <span v-else>
                      {{ selfData.df_min | thousands }}
                    </span>
                    -
                    <span>
                      {{ selfData.self_df_max | thousands }}
                    </span>
                  </p>
                </div>
                <div class="right">
                  <div class="title">{{ $returnBuySel("出货") }}</div>
                  <div class="set">
                    <van-switch
                      style="margin-top: 5px"
                      :value="selfData.on_duty_ds == 1"
                      size="18"
                      @input="changeDs"
                      active-color="#009aaa"
                      inactive-color="#cccccc"
                    />
                  </div>
                  <p
                    @click="showCheck"
                    class="selfCheck"
                    :style="{
                      color: $returnColor().color1,
                    }"
                  >
                    没有进单吗？小帮手检查
                  </p>
                  <!-- <p class="numF"><i></i></p> -->
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <div class="testRight" @click="$refs['ttest'].next()">
          <img src="@/assets/images/home page_select icon_right.png" alt="" />
        </div>
      </div>
      <div class="cardWrap">
        <div class="cardContent">
          <div
            v-if="selfData.can_payment"
            @click="$router.push({ path: 'ordersP' })"
            class="cardBox"
          >
            <p class="badge" v-if="selfData.payment_count * 1">
              {{ selfData.payment_count }}
            </p>
            <div>
              <img :src="$returnColor().path + '/icon1.png'" alt="" />
              <p class="name">{{ $returnBuySel("进货") }}</p>
            </div>
          </div>
          <div @click="$router.push({ path: 'ordersC' })" class="cardBox">
            <p class="badge" v-if="selfData.order_count * 1">
              {{ selfData.order_count }}
            </p>
            <div>
              <img :src="$returnColor().path + '/icon2.png'" alt="" />
              <p class="name">{{ $returnBuySel("出货") }}</p>
            </div>
          </div>
          <div
            @click="$router.push('/deposit')"
            class="cardBox"
            v-if="selfData.can_deposit == 1 || selfData.can_deposit_usdt == 1"
          >
            <div>
              <img :src="$returnColor().path + '/icon3.png'" alt="" />
              <p class="name">充值</p>
            </div>
          </div>
          <div class="cardBox" @click="$router.push('/withdraw')">
            <div>
              <img :src="$returnColor().path + '/icon4.png'" alt="" />
              <p class="name">提款</p>
            </div>
          </div>
          <div
            class="cardBox"
            @click="
              $router.push({
                path: 'myReport',
              })
            "
          >
            <div>
              <img :src="$returnColor().path + '/icon5.png'" alt="" />
              <p class="name">个人{{ $returnBuySel("报表") }}</p>
            </div>
          </div>
          <div
            class="cardBox"
            @click="
              $router.push({
                path: 'teamReport',
              })
            "
          >
            <div>
              <img :src="$returnColor().path + '/icon6.png'" alt="" />
              <p class="name">团队{{ $returnBuySel("报表") }}</p>
            </div>
          </div>
          <div
            class="cardBox"
            @click="
              $router.push({
                path: 'orderRecord',
              })
            "
          >
            <div>
              <img :src="$returnColor().path + '/icon7.png'" alt="" />
              <p class="name">{{ $returnBuySel("流水") }}</p>
            </div>
          </div>
          <div class="cardBox" @click="exchangeModal = true">
            <div>
              <img :src="$returnColor().path + '/icon8.png'" alt="" />
              <p class="name">红利转余额</p>
            </div>
          </div>
          <div
            v-if="selfData.can_transfer == 1"
            class="cardBox"
            @click="
              trans = {};
              transferModal = true;
            "
          >
            <div>
              <img :src="$returnColor().path + '/icon9.png'" alt="" />
              <p class="name">余额转让</p>
            </div>
          </div>
          <div
            v-if="selfData.check_card == 1"
            class="cardBox"
            @click="
              $router.push({
                path: 'checkCard',
              })
            "
          >
            <div>
              <img :src="$returnColor().path + '/icon10.png'" alt="" />
              <p class="name">审核卡片</p>
            </div>
          </div>
          <div
            class="cardBox"
            @click="showFAQ"
            v-if="
              question.length &&
              (selfData.m_id == 60007 || selfData.m_id == 60002)
            "
          >
            <div>
              <img :src="$returnColor().path + '/08.png'" alt="" />
              <p class="name">常见问题</p>
            </div>
          </div>
          <div
            v-if="selfData.m_id == 60007 || selfData.m_id == 60002"
            class="cardBox"
            @click="
              $router.push({
                path: 'orderCecordSend',
              })
            "
          >
            <div>
              <img :src="$returnColor().path + '/icon10.png'" alt="" />
              <p class="name">传送出货</p>
            </div>
          </div>
          <div
            v-if="selfData.m_id == 60007 || selfData.m_id == 60002"
            class="cardBox"
            @click="
              $router.push({
                path: 'orderPRecordSend',
              })
            "
          >
            <div>
              <img :src="$returnColor().path + '/icon10.png'" alt="" />
              <p class="name">传送进货</p>
            </div>
          </div>
          <div
            class="cardBox"
            @click="showSettingMail"
            v-if="mailSetting.length"
          >
            <div>
              <i
                class="far fa-envelope"
                style="font-size: 29px; margin-top: 14px"
                :style="{ color: $returnColor().color4 }"
              ></i>
              <p class="name">常用邮件</p>
            </div>
          </div>
          <div
            class="cardBox"
            @click="$router.push('/searchAcc')"
            v-if="$store.state.selfData.can_fsearch"
          >
            <div>
              <i
                class="fas fa-search"
                style="font-size: 29px; margin-top: 14px"
                :style="{ color: $returnColor().color4 }"
              ></i>
              <p class="name">查询帐号</p>
            </div>
          </div>
          <div
            class="cardBox"
            @click="$router.push('/searchCard')"
            v-if="$store.state.selfData.can_fcard"
          >
            <div>
              <i
                class="fas fa-search"
                style="font-size: 29px; margin-top: 14px"
                :style="{ color: $returnColor().color4 }"
              ></i>
              <p class="name">查询卡片</p>
            </div>
          </div>
          <i class="stateI"></i><i class="stateI"></i><i class="stateI"></i
          ><i class="stateI"></i><i class="stateI"></i>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import { Toast } from "vant";
import foot from "../components/footer";
import { mapState } from "vuex";
import NestedItem from "../components/nestedItem/index.vue";
export default {
  components: { foot, NestedItem },
  data() {
    return {
      exchangeModal: false,
      show: false,
      on_duty_ds: false,
      amount: "",
      annList: [],
      on_duty_df: false,
      transferModal: false,
      checkModal: false,
      checkData: false,
      trans: {},
      mailSettingModal: false,
      mailSetting: [],
      question: [],
      faqDialog: false,
      searchAccDialog: false,
    };
  },
  computed: {
    ...mapState(["orders", "pOrders", "selfData"]),
  },
  methods: {
    toggleShow(item) {
      if (item.show === undefined) {
        this.$set(item, "show", false);
      }
      item.show = !item.show;
    },

    showFAQ() {
      this.faqDialog = true;
    },
    onCopy() {
      this.$toast.success("已复制");
    },
    showSettingMail() {
      this.mailSettingModal = true;
    },
    retrunBgColor() {
      if (
        document.domain == "store.olzde8213.com" ||
        document.domain == "47.239.88.174" ||
        document.domain == "47.239.169.10"
      ) {
        return "background:black; color:white";
      }
    },
    retrunTitleColor() {
      if (
        document.domain == "store.olzde8213.com" ||
        document.domain == "47.239.169.10" ||
        document.domain == "47.239.88.174"
      ) {
        return "color:black";
      }
    },
    showMsg(msg) {
      if (!msg) return;
      this.$dialog.alert({
        message: msg,
      });
    },
    showCheck() {
      this.$http.get(`/mobile/selfCheck`).then((res) => {
        if (res.data.code == 0) {
          this.checkData = res.data.data;
          this.checkModal = true;
        }
      });
    },
    confirmTrans(method, done) {
      let vm = this;
      if (method == "confirm") {
        if (!this.trans.account) {
          this.$toast.fail("请输入账号");
        }
        if (!this.trans.amount) {
          this.$toast.fail("请输入金额");
        }
        if (!this.trans.withdraw_password) {
          this.$toast.fail("请输入提现密码");
        }
        this.$dialog.confirm({
          title: "请确认转账信息是否正确",
          message: `
              <p style="width:100%;text-align:left;margin:0;padding:0;padding-top:15px">转入账号: ${vm.trans.account}</p>
              <p style="width:100%;text-align:left;margin:0;padding:0">金额: ${vm.trans.amount}</p>`,
          beforeClose(method, done2) {
            if (method == "confirm") {
              vm.$http.post(`/mobile/transfer`, vm.trans).then((res) => {
                if (res.data.code == 0) {
                  vm.$store.dispatch("getSelf");
                  vm.$toast.success("成功");
                  done();
                } else {
                  done(false);
                }
                done2();
              });
            } else {
              done(false);
            }
            done2();
          },
        });
      } else {
        done();
      }
    },
    showContent(list) {
      this.$dialog.confirm({
        title: list.title,
        message: list.content,
        showCancelButton: false,
        messageHtml: true,
      });
    },
    changeDsBefore(method, done) {
      // selfData.alter_self_df_min == 1
      if (method == "confirm") {
        if (this.selfData.alter_self_df_min == 1) {
          if (this.selfData.self_df_min * 1 < this.selfData.df_min * 1) {
            this.$dialog.confirm({
              title: "提醒",
              message: "请输入有效范围",
              showCancelButton: false,
            });
            done(false);
            return;
          }
          if (this.selfData.self_df_max * 1 < this.selfData.self_df_min * 1) {
            this.$dialog.confirm({
              title: "提醒",
              message: "请输入有效范围",
              showCancelButton: false,
            });
            done(false);
            return;
          }
        }
        if (this.selfData.self_df_max * 1 > this.selfData.df_max * 1) {
          this.$dialog.confirm({
            title: "提醒",
            message: "请输入有效范围",
            showCancelButton: false,
          });
          done(false);
          return;
        }
        if (this.selfData.self_df_max * 1 > this.selfData.df_max * 1) {
          this.$dialog.confirm({
            title: "提醒",
            message: "请输入有效范围",
            showCancelButton: false,
          });
          done(false);
          return;
        }
        let sendData = {
          on_duty_df: this.on_duty_df ? 1 : 0,
          self_df_min: this.selfData.self_df_min,
          self_df_max: this.selfData.self_df_max,
        };
        if (!this.selfData.alter_self_df_min == 1) {
          delete sendData.self_df_min;
        }
        this.$http.post(`/mobile/personalSetting`, sendData).then((res) => {
          if (res.data.code == 0) {
            this.$store.commit("setSelf", res.data.data);
            // this.$store.dispatch("getSelf");
            done();
          } else {
            done(false);
          }
        });
      } else {
        done();
      }
    },
    confirmExchange(method, done) {
      if (method == "confirm") {
        this.$http
          .post(`/mobile/exchange`, {
            amount: this.amount,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$store.dispatch("getSelf");
              done();
            } else {
              done(false);
            }
          });
      } else {
        done();
      }
    },
    changeDs(checked) {
      this.$dialog
        .confirm({
          title: "提醒",
          message: "是否切自动" + this.$returnBuySel("出货") + "?",
        })
        .then(() => {
          this.$http
            .post(`/mobile/personalSetting`, {
              on_duty_ds: checked,
            })
            .then((res) => {
              if (res.data.code == 0) {
                if (this.$store.state.selfData.ds_close_duty && checked) {
                  this.$store.dispatch("useIdleTimeout", true);
                } else {
                  this.$store.dispatch("useIdleTimeout", false);
                }
                this.$store.commit("setSelf", res.data.data);
                // this.$store.dispatch("getSelf");
              }
            });
        });
    },
    changeDf(checked) {
      this.on_duty_df = !checked;
      this.show = true;
    },
    getOrder() {
      this.$store.dispatch("getOrder", { page: 1, status: 0 });
    },
    getPOrder() {
      this.$store.dispatch("getPOrder", { page: 1, status: 0 });
    },
    text(test) {
      Toast(test);
    },
  },
  created() {
    // this.getPOrder();
    // if (!this.$store.state.isSubscribe) {
    if (
      localStorage.getItem("token") ||
      // this.$cookie.get("token") ||
      this.$http.defaults.headers.common.Authorization
    ) {
      this.$store.dispatch("getSelf");
      setTimeout(() => {
        if (
          !this.$store.state.selfData ||
          (this.$store.state.selfData.m_id !== 60007 &&
            this.$store.state.selfData.m_id !== 60002)
          // &&
          // this.$store.state.selfData.m_id !== 116770
        )
          return;
        this.$http.get(`/mobile/settings`).then((res) => {
          if (res.data.code == 0) {
            let data = res.data.data;
            try {
              this.mailSetting = data.filter((e) => {
                return e.name == "邮件";
              })[0].setting;
              this.question = data.filter((e) => {
                return e.name == "問答";
              })[0].setting;
              // let idleData = data.filter((e) => {
              //   return e.name == "出貨閒置";
              // });
              // if (idleData.length) {
              //   this.$store.commit("setSelf", {
              //     idleSetting: idleData[0].setting,
              //   });
              // }
              // this.$store.state.commit;
            } catch {
              if (data[0]) {
                this.mailSetting = data[0].setting;
              }
            }
          }
        });
      }, 3000);
      this.$http.get(`/mobile/anns`).then((res) => {
        if (res.data.code == 0) {
          this.annList = res.data.data.sort((a, b) => a.is_top - b.is_top);
        }
      });
    }
    // }
  },
};
</script>
<style lang="scss" scoped>
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
  overflow: hidden;
}
.swipeWrap {
  display: flex;
  justify-content: center;
  // margin-top: 15px;
  margin-bottom: 15px;
  position: relative;
  .bsg {
    position: absolute;
    width: 377px;
    height: 227px;
  }
  .my-swipe {
    width: 90%;
    border-radius: 10px;
  }
}
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
.selectBtn {
  height: 55px;
  p {
    margin: 0 !important;
  }
}
.demo-home-nav__block {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  margin: 0 0 12px;
  padding-left: 20px;
  color: #323233;
  font-weight: 600;
  font-size: 14px;
  line-height: 40px;
  background: #f7f8fa;
  border-radius: 10px;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
  width: 175px;
}
.demo-home-nav__icon {
  position: absolute;
  top: 50%;
  right: 16px;
  width: 16px;
  height: 16px;
  margin-top: -8px;
}
.midContent {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  align-items: center;
  .left {
    flex: 1;
  }
  .right {
    flex: 1.5;
    .van-cell-group--inset {
      margin-bottom: 10px;
    }
    .van-cell {
      padding: 8px 12px !important;
    }
  }
}
.cardWrap {
  width: 100%;
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: #fff;
  // border-radius: 10px;
  // padding: 15px;
  margin-top: 15px;
  .cardTitle {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(gray, 0.3);
    flex-wrap: wrap;
    font-size: 14px;
    .tfInfo {
      margin: 0;
      width: 100%;
      font-size: 12px;
    }
    .right {
      display: flex;
      span {
        display: flex;
        width: 100%;
        align-items: center;
      }
    }
  }
  .cardContent {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 295px;
    .stateI {
      width: 80px;
      height: 0;
    }
    .cardBox {
      .badge {
        position: absolute;
        right: -5px;
        top: -5px;
        border-radius: 100px;
        width: 20px;
        height: 20px;
        font-size: 12px;
        background-color: red;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      position: relative;
      width: 80px;
      height: 80px;
      padding: 5px;
      // margin: 15px 5px;
      box-shadow: 0px 0px 5px rgba(#000000, 0.05);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 15px;
      background-color: #fff;
      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        height: 100%;
        img {
          width: 25px;
          margin-top: auto;
          margin-bottom: 10px;
        }
      }
      .img {
        font-size: 30px;
      }
      p {
        margin: 0;
      }
      .name {
        font-size: 14px;
        // margin-top: 20px;
      }
      .info {
        color: gray;
        font-size: 14px;
      }
    }
  }
}
.infoPay {
  margin: 0 10px;
  .van-cell__title {
    text-align: left;
  }
  margin-top: 15px;
}
.exchangeInfo {
  color: red;
  text-align: center;
}
.notifyBar {
  border-radius: 20px;
  background-color: #fff;
  height: 30px;
  width: 286px;
  margin: 0 auto;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.testLeft,
.testRight {
  display: flex;
  align-items: center;
  z-index: 999;
  position: absolute;
  top: 50%;
  transform: translateX(-50%);
}
.testLeft {
  left: 10px;
}
.testRight {
  right: 10px;
}
.leftIcon,
.rightIcon {
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.leftIcon {
  img {
    width: 15px;
    height: 15px;
  }
}
.rightIcon {
  img {
    width: 13px;
    height: 10px;
  }
}
.t1,
.t2 {
  background-color: #fff;
  height: 160px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 30px;
}
.t1 {
  width: 285px;
  display: flex;
  .title {
    font-size: 12px;
    color: #9d9b9b;
  }
  .left,
  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .numF {
      color: #333333;
      font-size: 12pt;
      line-height: 30px;
      margin-top: 5px;
    }
  }
  .left {
    width: 50%;
    display: flex;
    justify-content: center;
  }
  .right {
    display: flex;
    justify-content: center;
    width: 50%;
  }
  .content {
    width: 100%;
    display: flex;
  }
}
.t2 {
  width: 300px;
  display: flex;
  .set {
    display: flex;
    align-items: center;
    height: 35px;
    img {
      width: 15px;
      margin-left: 5px;
    }
  }
  .content {
    width: 100%;
    display: flex;
  }
  .title {
    font-size: 10px;
    color: #9d9b9b;
  }
  .left,
  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .numF {
      color: #333333;
      font-size: 14px;
      line-height: 35px;
      font-weight: 500;
    }
  }
  .left {
    width: 50%;
    display: flex;
    justify-content: center;
  }
  .right {
    display: flex;
    width: 50%;
    justify-content: flex-start;
  }
}
.loopWrap {
  display: flex;
  justify-content: center;
  .content {
    margin-top: 15px;
  }
}
.home {
  // background-image: attr(image url);
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  // background-attachment: fixed;
  min-height: 100vh;
}
.balanceWrap {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  .b1 {
    font-size: 10px;
    font-weight: bold;
  }
  .b2 {
    font-size: 24pt;
  }
}
.changeTitle {
  font-size: 11pt;
  font-weight: bold;
  .active {
    color: #9d9b9b;
  }
  span {
    margin-left: 5px;
    margin-right: 5px;
  }
}

.numF {
  font-family: "Montserrat" !important;
}
.selfCheck {
  cursor: pointer;
  // color: rgb(99, 205, 161);
  font-size: 12px !important;
  line-height: 35px;
}
i.err {
  color: red;
}
i.success {
  color: green;
}

.faqDilog {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 50px;
  background-color: #e4e4e4;
  z-index: 9999;
  overflow: scroll;

  .close {
    position: absolute;
    right: 10px;
    top: 2px;
  }
  .faqContent {
    padding: 10px 5px;
  }
  .faqTitle {
    height: 39px;
    background-color: white;
    color: black;
    font-size: 14px;
    text-align: center;
    line-height: 39px;
  }
  h3,
  h4 {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-all;
  }
  .nested {
    margin-bottom: 10px;
    > h3 {
      background-color: #46b7c1;
      border-radius: 20px;
      color: white;
      padding: 6px 12px;
      font-size: 14px;
      margin-top: 0;
      position: relative;
      min-height: 40px;
      display: flex;
      align-items: center;
      &.active {
        background-color: #28919a;
      }
      .arrow {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        height: 12px;
        &.active {
          transform: translateY(-50%) rotate(90deg);
        }
      }
    }
  }
}
</style>
